/**
 * Device-Hint server function — erster SSR-Frame soll das richtige Layout
 * treffen (Desktop vs. Mobile), obwohl der Server keine Fensterbreite kennt.
 *
 * Warum es das gibt (Betreiber-Meldung 07.08.2026, S63): /kayit-ol startete
 * mit useState(false) fuer isDesktop und mass die Breite erst im useEffect
 * NACH dem ersten Paint. Weil die Route voll SSR-gerendert ausgeliefert wird,
 * malte der Browser erst das Mobile-Markup des Servers und sprang nach der
 * Hydration sichtbar auf Desktop um ("zwei Seiten uebereinander"-Flash).
 *
 * Loesung: Der Server raet das Geraet aus den Request-Headern und rendert
 * gleich die passende Variante. Der Client misst nach dem Mount weiterhin
 * echt (resize-Listener bleibt) — der Hint bestimmt nur den ERSTEN Frame,
 * die Messung bleibt die Wahrheit (Grenzfall schmales Desktop-Fenster
 * korrigiert sich einen Frame spaeter, wie bisher immer).
 *
 * Headers: Chromium sendet `sec-ch-ua-mobile` (?1 = Mobile, ?0 = Desktop)
 * ungefragt; Safari/Firefox nicht -> Fallback User-Agent-Sniff. iPad-Safari
 * meldet sich als Macintosh (Desktop) — bei ~768-1024px Viewport greift dann
 * die Client-Korrektur, akzeptiert.
 *
 * Muster wie lib/server-fns/bootstrap.ts: createServerFn-Wrapper noetig, weil
 * getRequest ein server-only Import ist (direkter Import in einer Route-Datei
 * wuerde den Client-Build brechen).
 */
import { createServerFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'

const MOBILE_UA_RE = /Mobi|Android|iPhone|iPad|IEMobile|Opera Mini/i

export const getDesktopHint = createServerFn({ method: 'GET' }).handler(async () => {
  const req = getRequest()
  const chMobile = req.headers.get('sec-ch-ua-mobile')
  if (chMobile === '?1') return { desktop: false }
  if (chMobile === '?0') return { desktop: true }
  const ua = req.headers.get('user-agent') ?? ''
  return { desktop: !MOBILE_UA_RE.test(ua) }
})
